import { useUI } from './useUI'
import { useCompanySpaces, useSpaces, usePermissionsAssociated } from '../queries/useCompanyQueries'
import { getCurrentURL } from '../utils/utils'

export const useApp = () => {
  const ui = useUI()
  const url = getCurrentURL()

  const { data: companyData, isLoading: isLoadingCompany } = useCompanySpaces()

  const { data: spacesData, isLoading: isLoadingSpaces } = useSpaces()

  const { data: permissionsData, isLoading: isLoadingPermissions } = usePermissionsAssociated()

  // Combinar datos de UI con datos de queries
  return {
    ...ui,
    iDCompany: companyData,
    areasData: spacesData,
    loading: isLoadingCompany || isLoadingSpaces || isLoadingPermissions || ui.loading,
    permissionsData,
    companyData: companyData?.body?.content[0]
      ? {
          email: companyData.body.content[0].mail,
          phone: companyData.body.content[0].phone,
          socials: companyData.body.content[0].listSocialNetwork?.reduce((acc: any, item: any) => {
            acc[item.name] = item.url
            return acc
          }, {}),
          logofooter: '/images/favicon.ico',
          logoheader: companyData.body.content[0].urlLog
        }
      : null
  }
}
